import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum } from 'src/app/api/models';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { PartnerServiceProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/partner-service-produkt-enum';
import { PartnerPostnummerService, PartnerService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-partner-postnummer-edit-dialog',
  templateUrl: './partner-postnummer-edit-dialog.component.html',
  styleUrls: ['./partner-postnummer-edit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PartnerPostnummerEditDialogComponent implements OnInit {
  form: UntypedFormGroup;
  postnummerForm: UntypedFormGroup;
  minValidToDate: Date;
  partnere: PartnerBaseDto[] = [];
  products: string[] = [];

  selectedPartner: PartnerBaseDto;
  noPartner: boolean = false;
  selectedProduct: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
  minToDate: Date;
  currentDate: Date = new Date();

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private service: PartnerPostnummerService,
    private partnerService: PartnerService,
    private errorHandler: ErrorHandlerService,
    private loader: LoaderService,
    public dialogRef: MatDialogRef<PartnerPostnummerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public postnummereFraTil: any,
  ) {}

  async ngOnInit(): Promise<void> {
    this.minValidToDate = new Date();
    this.currentDate = new Date();
    this.minToDate = new Date();

    this.form = this.formBuilder.group({
      postnummerFra: [parseInt(this.postnummereFraTil.fra), [Validators.required, Validators.min(1000), Validators.max(10000)]],
      postnummerTil: [parseInt(this.postnummereFraTil.til), [Validators.min(1000), Validators.max(10000)]],
      produkt: [this.postnummereFraTil.produkt ?? '', [Validators.required]],
      partner: ['', [Validators.required]],
      frieTilkald: [false],
      noPartner: [false],
      validFrom: [this.currentDate, [Validators.required]],
      validTo: [this.currentDate, [Validators.required]],
    });

    this.products = Object.values(PartnerServiceProduktEnum).map((value) => value.toString());

    await this.fetchPartnersAsync();
  }

  get isEdit() {
    return this.postnummereFraTil.isEdit == true;
  }

  async fetchPartnersAsync() {
    await this.partnerService
      .getActivePartnere({
        caller: EGIS_SERVICE_CALLER,
      })
      .toPromise()
      .then((response) => {
        this.partnere = response.sort((a, b) => (a.name < b.name ? -1 : 1));
      })
      .catch((error) => {
        this.errorHandler.HandleError(error);
      })
      .finally(() => {});
  }

  onPartnerChange(partner: PartnerBaseDto) {
    this.selectedPartner = partner;

    if (partner.validTo != null) {
      this.minValidToDate = new Date(partner.validTo);
    } else {
    }
  }

  async save() {
    if (!this.form.valid) {
    } else {
      var produkt: PartnerServiceProduktEnum = PartnerServiceProduktEnum[this.form.get('produkt').value];

      this.loader.show();
      if (this.isEdit) {
        await this.service
          .addPostnummerServicePartner({
            partnerNo: this.form.get('noPartner').value == false ? this.form.get('partner').value.partnerNo : 0,
            partnerServiceProduktEnum: produkt,
            fromPostnummer: this.form.get('postnummerFra').value,
            toPostnummer: this.form.get('postnummerTil').value,
            allowFrieTilkald: this.form.get('frieTilkald').value,
            validFrom: this.form.get('validFrom').value.toOkDateString(),
            caller: EGIS_SERVICE_CALLER,
          })
          .toPromise()
          .then((response) => {
            this.dialogRef.close(response);
          })
          .catch((error) => {
            this.errorHandler.HandleError(error);
          })
          .finally(() => {
            this.loader.hide();
          });
      } else {
        await this.service
          .deletePostnummerServicePartner({
            partnerNo: this.noPartner != true ? this.form.get('partner').value.partnerNo : null,
            partnerServiceProduktEnum: produkt,
            fromPostnummer: this.form.get('postnummerFra').value,
            toPostnummer: this.form.get('postnummerTil').value,
            validTo: this.form.get('validTo').value.toOkDateString(),
            caller: EGIS_SERVICE_CALLER,
          })
          .toPromise()
          .then((response) => {
            this.dialogRef.close(response);
          })
          .catch((error) => {
            this.errorHandler.HandleError(error);
          })
          .finally(() => {
            this.loader.hide();
          });
      }
    }
  }
  onNoPartnerChange(event: MatCheckboxChange) {
    this.noPartner = event.checked;
    if (this.noPartner) {
      this.form.controls.partner.clearValidators();
      this.form.controls.partner.setValue(null);
    } else {
      this.form.controls.partner.setValidators([Validators.required]);
    }
    this.form.controls.partner.updateValueAndValidity();
  }
}
